import { render, staticRenderFns } from "./mem_sup_title.vue?vue&type=template&id=2a76a27c&scoped=true&"
import script from "./mem_sup_title.vue?vue&type=script&lang=js&"
export * from "./mem_sup_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76a27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a76a27c')) {
      api.createRecord('2a76a27c', component.options)
    } else {
      api.reload('2a76a27c', component.options)
    }
    module.hot.accept("./mem_sup_title.vue?vue&type=template&id=2a76a27c&scoped=true&", function () {
      api.rerender('2a76a27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/sup/mem_sup_title.vue"
export default component.exports